import { Link } from "react-router-dom";
import { Lock, LockOpen, MonitorPlay } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const SealPanel = ({ count, onUnseal }) => (
  <section data-testid="seal-panel" className="relative border border-emerald-400/40 bg-emerald-400/5 p-8">
    <span className="corner corner-tl" /><span className="corner corner-br" />
    <p className="lab-label flex items-center gap-2 !text-emerald-300"><Lock size={14} /> Vocabulary sealed</p>
    <h2 className="mt-2 font-display text-2xl sm:text-3xl font-black uppercase tracking-[0.12em] text-slate-50">The site is open</h2>
    <p className="mt-3 max-w-xl text-sm text-slate-400">
      <span data-testid="seal-panel-count" className="font-mono text-emerald-300">{count}</span> objects are locked. The bench is hidden from the kiosk and
      objects cannot be edited. Unseal only if you need to reprogram something.
    </p>
    <div className="mt-6 flex flex-wrap gap-3">
      <Link data-testid="seal-panel-kiosk-link" to="/" className="lab-btn-primary"><MonitorPlay size={16} /> Open kiosk</Link>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button data-testid="unseal-button" className="lab-btn-ghost"><LockOpen size={16} /> Unseal to edit</button>
        </AlertDialogTrigger>
        <AlertDialogContent className="lab-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display uppercase tracking-widest">Unseal the vocabulary?</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-400">The kiosk returns to calibration mode and the Setup button reappears until you seal again.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="lab-btn-ghost">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="unseal-confirm" className="lab-btn-danger" onClick={onUnseal}>Unseal</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  </section>
);
